import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { calibrationProcedureKeys } from '@/features/calibration-procedures';

interface CalibrationProcedure {
  _id: string;
  name: string;
  measurement_templates?: Array<{
    measurand: string;
    target_measurement_uncertainty?: number;
  }>;
}

interface V4CalibrationProcedure {
  id: string;
  mongoProcedureId: string;
  name: string;
  measurementTemplates?: Array<{
    measurand: string;
    target_measurement_uncertainty?: number;
  }>;
}

interface V4Response {
  calibrationProcedures: V4CalibrationProcedure[];
  total: number;
  page: number;
  pageLength: number;
}

export function useCalibrationProcedures() {
  return useQuery({
    queryKey: calibrationProcedureKeys.lists(),
    queryFn: async () => {
      const data = await api.get<V4Response>(
        '/v4/calibration-procedures',
        { pageLength: 100 },
      );
      // Map V4 response to the shape expected by SensorManagementSection
      return (data.calibrationProcedures || []).map((p): CalibrationProcedure => ({
        _id: p.mongoProcedureId,
        name: p.name,
        measurement_templates: p.measurementTemplates,
      }));
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
